import React from 'react';
import SEO from '../SEO';
import { seoConfig, generateBreadcrumbJsonLd } from '../../utils/seoData';

const TermsOfUsePage: React.FC = () => {
  const breadcrumbJsonLd = generateBreadcrumbJsonLd([
    { name: 'Ana Sayfa', url: 'https://winnomi.com' },
    { name: 'Kullanım Koşulları', url: 'https://winnomi.com/kullanim-kosullari' },
  ]);

  return (
    <>
      <SEO
        {...seoConfig.terms}
        jsonLd={[
          breadcrumbJsonLd,
          {
            '@context': 'https://schema.org',
            '@type': 'WebPage',
            name: 'Kullanım Koşulları',
            description: seoConfig.terms.description,
            url: 'https://winnomi.com/kullanim-kosullari',
            datePublished: '2025-11-09',
            dateModified: '2025-11-09',
          },
        ]}
      />
      <main className="min-h-screen bg-slate-950 text-slate-100">
      <div className="max-w-5xl mx-auto px-6 py-24 space-y-12">
        <header className="space-y-4">
          <p className="text-sm uppercase tracking-widest text-purple-300">Kullanım Koşulları</p>
          <h1 className="text-3xl md:text-4xl font-semibold text-white">
            Winnomi AI Platformu Kullanım Koşulları
          </h1>
          <p className="text-slate-400">
            Güncelleme tarihi: 09 Kasım 2025
          </p>
          <p className="text-slate-300 leading-relaxed">
            Bu kullanım koşulları (“Koşullar”), Winnomi AI platformu aracılığıyla sunulan tüm hizmetleri
            düzenlemekte olup, TARIK ÇEKEMOĞLU CONCEPTION TEAM DANIŞMANLIK HİZMETLERİ (“Şirket”) ile
            platforma erişen veya platformu kullanan gerçek ya da tüzel kişiler (“Kullanıcı”) arasında akdedilmiştir.
            Platforma erişerek veya platformu kullanarak Koşullar’ı okuduğunuzu, anladığınızı ve kabul ettiğinizi
            beyan edersiniz. Koşullar’ı kabul etmiyorsanız platformu kullanmamalısınız.
          </p>
        </header>

        <section className="space-y-6">
          <h2 className="text-2xl font-semibold text-white">1. Tanımlar ve Yorum</h2>
          <div className="space-y-4 text-slate-300 leading-relaxed">
            <p>
              <strong className="text-white">Platform:</strong> winnomi.com alan adı ve alt alan adları üzerinden
              erişilen web uygulaması ile Winnomi AI mobil uygulaması dahil olmak üzere Şirket tarafından
              yönetilen tüm sosyal medya kanalları ifade eder.
            </p>
            <p>
              <strong className="text-white">Hizmet:</strong> Yapay zeka destekli içerik önerileri, performans
              analitiği, kitle yönetimi ve benzeri özellikler de dahil olmak üzere Platform üzerinden sunulan tüm
              sosyal medya ürün ve hizmetleri ifade eder.
            </p>
            <p>
              <strong className="text-white">Kullanıcı:</strong> Platform’a ziyaretçi olarak erişen, kayıt yaptıran veya
              Hizmetleri kullanan gerçek kişi veya tüzel kişiliklerdir.
            </p>
            <p>
              <strong className="text-white">Üyelik:</strong> Platform’a kayıt olmak suretiyle oluşturulan, Kullanıcı’nın
              kimlik bilgilerinin doğrulandığı ve kendisine özel hizmetlerin sunulduğu hesap.
            </p>
          </div>
        </section>

        <section className="space-y-6">
          <h2 className="text-2xl font-semibold text-white">2. Koşulların Kapsamı ve Değişiklikler</h2>
          <div className="space-y-4 text-slate-300 leading-relaxed">
            <p>
              Şirket, Koşullar’ı gerektiğinde tek taraflı olarak güncelleyebilir. Değişiklikler Platform’da
              yayınlandığı tarihte yürürlüğe girer ve bu tarihten sonra Platform’un kullanılmaya devam edilmesi,
              güncel Koşullar’ın kabul edildiği anlamına gelir. Önemli değişiklikler durumunda Kullanıcı’ya e-posta
              veya uygulama içi bildirim ile bilgi verilebilir.
            </p>
            <p>
              Koşullar’ın yürürlükteki mevzuatın emredici hükümleriyle çelişmesi halinde, ilgili hüküm yerine
              mevzuat hükümleri uygulanır. Diğer hükümler geçerliliğini korur.
            </p>
          </div>
        </section>

        <section className="space-y-6">
          <h2 className="text-2xl font-semibold text-white">3. Üyelik Koşulları ve Hesap Güvenliği</h2>
          <div className="space-y-4 text-slate-300 leading-relaxed">
            <p>
              Platform’a üye olabilmek için 18 yaşını doldurmuş olmak ve gerekli kimlik bilgilerini eksiksiz ve
              doğru şekilde paylaşmak gerekir. Şirket, bilgilerin doğruluğunu teyit etme ve uygun bulmadığı
              başvuruları reddetme hakkını saklı tutar.
            </p>
            <p>
              Kullanıcı, hesap bilgilerini (kullanıcı adı, parola, doğrulama kodları vb.) üçüncü kişilerle
              paylaşmamayı ve yetkisiz erişimleri engellemek için gerekli önlemleri almayı kabul eder. Şirket,
              hesabın yetkisiz kişilerce kullanılmasından kaynaklanan zararlardan sorumlu tutulamaz.
            </p>
            <p>
              Şirket, mevzuata aykırı kullanım, güvenlik ihlali şüphesi veya Platform bütünlüğünü tehdit eden
              durumlar tespit ettiğinde Kullanıcı hesabını geçici veya kalıcı olarak askıya alma hakkına sahiptir.
            </p>
          </div>
        </section>

        <section className="space-y-6">
          <h2 className="text-2xl font-semibold text-white">4. Hizmetlerin Kullanımı ve Kullanıcı Yükümlülükleri</h2>
          <div className="space-y-4 text-slate-300 leading-relaxed">
            <p>
              Kullanıcı, Platform’u yalnızca hukuka uygun amaçlarla ve Koşullar’a uygun şekilde kullanmayı kabul
              eder. Kullanıcı, Platform aracılığıyla sağladığı içeriklerin doğruluğundan, güncelliğinden ve üçüncü
              kişilerin haklarını ihlal etmemesinden sorumludur.
            </p>
            <p>
              Kullanıcılar, Platform üzerindeki veri analizi sonuçlarını ve önerileri yalnızca kendi iç işleyişlerinde
              referans olarak kullanmalı, bu verileri üçüncü kişilerle paylaşmadan önce ilgili tarafların açık rızasını
              almalıdır.
            </p>
            <p>
              Spam, kötü amaçlı yazılım dağıtımı, yetkisiz erişim girişimleri, rekabet hukuku ihlalleri veya mevzuata
              aykırı pazarlama faaliyetleri Platform kullanımına kesinlikle aykırıdır. Şirket, bu tür ihlalleri tespit
              ettiğinde hesabı derhal kapatma ve hukuki yollara başvurma hakkını saklı tutar.
            </p>
          </div>
        </section>

        <section className="space-y-6">
          <h2 className="text-2xl font-semibold text-white">5. Ücretlendirme, Faturalama ve İade Politikası</h2>
          <div className="space-y-4 text-slate-300 leading-relaxed">
            <p>
              Platform’un belirli özellikleri ücretli olabilir. Ücretli paketler ve ödeme koşulları Platform’da
              duyurulur. Şirket, fiyatlarda değişiklik yapma hakkını saklı tutar; değişiklikler yeni dönem ödemeleri
              için geçerlidir.
            </p>
            <p>
              Ödemeler, Şirket’in anlaşmalı olduğu ödeme kuruluşları üzerinden alınır. Kredi kartı ile yapılan
              ödemelerde 3D Secure gibi güvenlik yöntemlerinin kullanılması talep edilebilir.
            </p>
            <p>
              Fatura talep eden Kullanıcı, ticari unvan ve vergi numarası gibi bilgileri zamanında iletmekle
              yükümlüdür. sosyal medya içerik niteliğinde olan hizmetlerde, hizmetin ifasına başlanmasından sonra
              cayma hakkı KVKK ve Mesafeli Sözleşmeler Mevzuatı uyarınca sınırlandırılabilir.
            </p>
            <p>
              İade ve fesih talepleri, Platform’da yayınlanan iade politikası çerçevesinde değerlendirilir. Haksız
              iade talepleri reddedilebilir.
            </p>
          </div>
        </section>

        <section className="space-y-6">
          <h2 className="text-2xl font-semibold text-white">6. Fikri ve Sınai Mülkiyet Hakları</h2>
          <div className="space-y-4 text-slate-300 leading-relaxed">
            <p>
              Platform’daki yazılım, veritabanı, görsel tasarımlar, logolar ve ticari markalar da dahil olmak üzere
              tüm içerikler Şirket’e veya lisans verenlere aittir. Kullanıcı, yazılı izin olmaksızın bu içerikleri
              çoğaltamaz, kopyalayamaz, yayınlayamaz, satamaz veya türev çalışmalar üretemez.
            </p>
            <p>
              Kullanıcı tarafından Platform’a yüklenen içerikler, Kullanıcı’nın mülkiyetinde kalmaya devam eder;
              ancak Kullanıcı, bu içeriklerin Platform’da görüntülenmesi, işlenmesi ve veri analizi süreçlerinde
              kullanılabilmesi için Şirket’e münhasır olmayan, devredilebilir ve alt lisanslanabilir bir kullanım
              hakkı verir.
            </p>
          </div>
        </section>

        <section className="space-y-6">
          <h2 className="text-2xl font-semibold text-white">7. Gizlilik ve Kişisel Verilerin Korunması</h2>
          <div className="space-y-4 text-slate-300 leading-relaxed">
            <p>
              Şirket, kullanıcıların kişisel verilerini KVKK ve ilgili mevzuata uygun olarak işler. Ayrıntılar
              Platform’da yayınlanan Winnomi AI Gizlilik Politikası ve KVKK Aydınlatma Metni’nde açıklanmıştır.
            </p>
            <p>
              Kullanıcı, gerektiğinde açık rıza beyanlarını sağlayacağını ve Platform’un veri işleme süreçlerine
              ilişkin bilgilendirmeleri takip edeceğini kabul eder.
            </p>
          </div>
        </section>

        <section className="space-y-6">
          <h2 className="text-2xl font-semibold text-white">8. Sorumluluğun Sınırlandırılması</h2>
          <div className="space-y-4 text-slate-300 leading-relaxed">
            <p>
              Platform, “olduğu gibi” sunulmaktadır. Şirket, Hizmetlerin kesintisiz, hatasız veya belirli sonuçları
              garanti edeceğine dair taahhütte bulunmaz. Kullanıcı, Hizmetlerden elde ettiği sonuçları kendi
              karar ve riskleri doğrultusunda kullanır.
            </p>
            <p>
              Şirket; veri kaybı, gelir kaybı, itibar zedelenmesi veya üçüncü kişilerin iddiaları dahil olmak üzere
              dolaylı zararlar için sorumluluk kabul etmez. Bu sınırlandırma, Şirket’in ağır kusuru veya kastı ile
              oluşan zararlara uygulanmaz.
            </p>
          </div>
        </section>

        <section className="space-y-6">
          <h2 className="text-2xl font-semibold text-white">9. Üçüncü Taraf Hizmetler ve Entegrasyonlar</h2>
          <div className="space-y-4 text-slate-300 leading-relaxed">
            <p>
              Platform, sosyal ağ API’leri, reklam platformları, bulut altyapıları ve diğer üçüncü taraf hizmetleri
              ile entegre çalışabilir. Bu hizmetlerin kullanımında ilgili platformların kendi kullanım koşulları ve
              gizlilik politikaları geçerli olacaktır. Şirket, üçüncü taraf platformların işlem ve tasarruflarından
              sorumlu tutulamaz.
            </p>
            <p>
              Kullanıcı, kendi API anahtarlarını veya hesabını Platform’a tanımladığında, bu hesapların güvenliği
              ve yetkilendirilmesi ile ilgili tüm sorumluluğu üstlenir.
            </p>
          </div>
        </section>

        <section className="space-y-6">
          <h2 className="text-2xl font-semibold text-white">10. Mücbir Sebep</h2>
          <div className="space-y-4 text-slate-300 leading-relaxed">
            <p>
              Doğal afetler, yangın, sel, salgın hastalık, savaş, terör eylemleri, grev ve lokavtlar, enerji kesintisi,
              telekom altyapısındaki arızalar, devlet müdahaleleri ve benzeri öngörülemeyen olaylar mücbir
              sebep olarak kabul edilir. Mücbir sebep durumunda taraflar, yükümlülüklerini yerine getirememekten
              doğrudan sorumlu tutulamaz; ancak bu durumu derhal diğer tarafa bildirir ve etkileri azaltmak için
              makul çabayı gösterir.
            </p>
          </div>
        </section>

        <section className="space-y-6">
          <h2 className="text-2xl font-semibold text-white">11. Fesih ve Askıya Alma</h2>
          <div className="space-y-4 text-slate-300 leading-relaxed">
            <p>
              Şirket, Koşullar’a aykırılık, ödenmemiş borç, güvenlik riski veya mevzuata aykırı kullanım tespit
              ettiğinde Kullanıcı hesabını askıya alabilir veya feshedebilir. Kullanıcı, hesabını dilediği zaman
              kapatma hakkına sahiptir; ancak fesih tarihine kadar doğmuş borç ve yükümlülükler devam eder.
            </p>
            <p>
              Fesih sonrası Kullanıcı verilerinin saklama süreleri, KVKK ve ilgili mevzuata uygun şekilde belirlenir.
            </p>
          </div>
        </section>

        <section className="space-y-6">
          <h2 className="text-2xl font-semibold text-white">12. Uyuşmazlıkların Çözümü</h2>
          <div className="space-y-4 text-slate-300 leading-relaxed">
            <p>
              Koşullar’ın yorumlanmasında ve uygulanmasında Türk hukuku geçerlidir. Taraflar, öncelikle iyi niyet
              çerçevesinde müzakere yoluyla uyuşmazlıkları çözmeyi kabul eder. Çözülemeyen uyuşmazlıklarda
              İstanbul Anadolu Adliyesi Mahkemeleri ve İcra Daireleri yetkilidir.
            </p>
          </div>
        </section>

        <section className="space-y-6">
          <h2 className="text-2xl font-semibold text-white">13. Bildirimler ve İletişim</h2>
          <div className="space-y-4 text-slate-300 leading-relaxed">
            <p>
              Şirket’e yöneltilecek bildirimler yazılı olarak veya Platform’da belirtilen iletişim kanallarından
              yapılmalıdır. Elektronik posta yoluyla gönderilen bildirimlerin alınmış sayılabilmesi için Kullanıcı’nın
              Şirket kayıtlarında bulunan e-posta adresini kullanması gerekir.
            </p>
            <div className="space-y-1">
              <p><strong className="text-white">Unvan:</strong> TARIK ÇEKEMOĞLU CONCEPTION TEAM DANIŞMANLIK HİZMETLERİ</p>
              <p><strong className="text-white">Adres:</strong> MASLAK MAH. AOS 55. SK. 42 MASLAK A BLOK NO: 2 İÇ KAPI NO: 25 SARIYER / İSTANBUL PK: 34475</p>
              <p><strong className="text-white">Telefon:</strong> +90 (546) 597 56 43</p>
              <p><strong className="text-white">E-posta:</strong> info@winnomi.com</p>
            </div>
          </div>
        </section>

        <section className="space-y-6">
          <h2 className="text-2xl font-semibold text-white">14. Yürürlük</h2>
          <p className="text-slate-300 leading-relaxed">
            Bu Koşullar, Platform’da yayınlandığı tarihte yürürlüğe girer. Platform’un cevrimiçi ortamda kolayca
            erişilebilir olması sağlanır ve Kullanıcı’nın Koşullar’a her zaman ulaşabilmesi için gerekli teknik
            imkânlar sunulur.
          </p>
        </section>
      </div>
    </main>
    </>
  );
};

export default TermsOfUsePage;

